<app-dashboard-option [categories]="['CELL']" [label]="'COLUMNS'" [information]="'PIXEL'">
  <div app-dashboard-option-content>
    <app-number [value]="cell.columns" (sendValue)="receiveValue($event)" [color]="color" [min]="1" [max]="200" [step]="5"></app-number>
  </div>
</app-dashboard-option>